import newMessageSound from './message-alert.mp3';

export const soundType: Record<string, string> = {
  newMessage: newMessageSound,
};
